<template>
    <section class="userSteps">
         <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row">
            <div class="col-12">
                <router-link class="d-flex align-items-center backBtn medium" to="/add-trading-account">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('mannual_proof.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12" v-if="Object.keys(store.brokersList).length && store.brokersList.brokers">
                <div class="mainTitle d-flex align-items-center justify-content-between mb-4">
                    <h3 class="mb-0 clash">{{$t('select_broker.text1')}}<span class="bgTitle dark">{{$t('select_broker.text2')}}</span></h3>
                    <!-- <label class="customCheckBox mb-0"> {{$t('select_broker.text10')}}
                        <input type="checkbox"  v-model="showFreeCopy" />
                        <span class="checkmark"></span>
                    </label> -->
                </div>
                <div class="nativeBroker" v-if="getparticularBrokersList('INTEGRATED').length">
                    <h4>{{$t('select_broker.text11')}}</h4>
                    <p>{{$t('select_broker.text12')}}</p>
                    <ul class="selectBrokertList">
                        <li class="d-flex align-items-center justify-content-between flex-wrap" v-for="item,key in getparticularBrokersList('INTEGRATED')" :key="key">
                            <a class="clickAble flex-wrap d-flex align-items-center justify-content-between" href="javascript:void(0)" @click="SignUpUser(item)" :class="[{'disabled' : !item.availableToUser}]">
                                <span class="semibold dark d-flex align-items-center">
                                    <img class="me-2" :src="'https://zulutrade.com/'+item.smallLogoUrl" :alt="item.name" :title="item.name" />
                                    {{item.name}}
                                </span>
                                <!-- <div class="d-flex align-items-center copyWrap">
                                    <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{$t('select_broker.text3')}}</span>
                                    <div class="tooltipbutton">
                                        <span class="tooltiptext">{{$t('select_broker.text4')}}</span>
                                        <span class="infoIcon position-relative">
                                            <vue-feather class="opcity ms-1" type="info" size="20"></vue-feather>
                                        </span>
                                    </div>
                                    <span class="badge rounded-pill bg-warning text-dark ms-3" v-if="Object.keys(store.userAccoutDetail).length && store.userAccoutDetail.integratedBrokerStatus && ((store.userAccoutDetail.integratedBrokerStatus.length && !store.userAccoutDetail.integratedBrokerStatus[0].completed) || (store.userAccoutDetail.requiredActions && store.userAccoutDetail.requiredActions.length))">{{$t('select_broker.text5')}}</span>
                                </div> -->
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="nativeBroker" v-if="Object.keys(store.flavorData).length && store.flavorData?.flavorId && (store.flavorData?.flavorId == 1 || store.flavorData?.flavorId == 38)">
                    <h4>{{$t('select_broker.text13')}}</h4>
                    <p class="mb-0">{{$t('select_broker.text14')}}</p>
                    <p>{{$t('select_broker.text15')}}</p>
                    <h6 class="mt-4 bold" v-if="store.flavorData?.flavorId == 38">{{$t('select_broker.text16')}}</h6>
                    <div class="allBrokers mt-3" v-if="store.flavorData?.flavorId == 38 && getparticularBrokersList('CO_BRANDED',store.flavorData.flavorId,'EU').length">
                        <!-- <div class="d-flex align-items-center justify-content-between mb-3">
                            <h4 class="mb-0">{{$t('select_broker.text6')}}</h4>
                            <float-label class="form-group w-220 mb-0 h-40">
                                <input type="text" class="form-control" placeholder="Search Broker" />
                            </float-label>
                        </div> -->
                        <ul class="selectBrokertList">
                            <li class="d-flex align-items-center justify-content-between flex-wrap" v-for="item,key in getparticularBrokersList('CO_BRANDED',store.flavorData.flavorId,'EU')" :key="key">
                                <a @click="(euaccordian != key) ? euaccordian = key : -1" class="clickAble d-flex align-items-center justify-content-between" href="javascript:void(0)" :class="[{'disabled' : !item.availableToUser}]">
                                    <span class="dark semibold d-flex align-items-center">
                                        <img class="me-2" :src="'https://zulutrade.com/'+item.smallLogoUrl" :alt="item.name" :title="item.name" />
                                        {{item.name}}
                                    </span>
                                    <!-- <div class="d-flex align-items-center copyWrap" v-if="item.integrationMode == 'CO_BRANDED'">
                                        <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{$t('select_broker.text3')}}</span>
                                        <div class="tooltipbutton">
                                            <span class="tooltiptext">{{$t('select_broker.text4')}}</span>
                                            <span class="infoIcon position-relative">
                                                <vue-feather class="opcity ms-1" type="info" size="20"></vue-feather>
                                            </span>
                                        </div>
                                    </div> -->
                                </a>
                                <div class="showData w-100 border-top p-3" :class="euaccordian == key?'d-block':'d-none'">
                                    <p class="dark medium">{{$t('select_broker.text7')}}</p>
                                    <div class="d-flex align-items-center flex-wrap dualButton">
                                        <a  class="grd_btn me-4" :href="item.signupUrl" target="_blank" v-if="item.signupUrl">{{$t('select_broker.text8')}}</a>
                                        <router-link to="/broker-account" class="border_btn br-50 gray">{{$t('select_broker.text9')}}</router-link>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <h6 class="mt-4 bold" v-if="store.flavorData?.flavorId == 1">{{$t('select_broker.text17')}}</h6>
                    <div class="allBrokers mt-3" v-if="store.flavorData?.flavorId == 1 && getparticularBrokersList('CO_BRANDED',store.flavorData.flavorId,'GLOBAL')">
                        <!-- <div class="d-flex align-items-center justify-content-between mb-3">
                            <h4 class="mb-0">{{$t('select_broker.text6')}}</h4>
                            <float-label class="form-group w-220 mb-0 h-40">
                                <input type="text" class="form-control" placeholder="Search Broker" />
                            </float-label>
                        </div> -->
                        <ul class="selectBrokertList">
                            <li class="d-flex align-items-center justify-content-between flex-wrap" v-for="item,key in getparticularBrokersList('CO_BRANDED',store.flavorData.flavorId,'GLOBAL')" :key="key">
                                <a @click="(globalaccordian != key) ? globalaccordian = key : -1" class="clickAble d-flex align-items-center justify-content-between" href="javascript:void(0)" :class="[{'disabled' : !item.availableToUser}]" v-if="parseInt(item?.id) != 275">
                                    <span class="dark semibold d-flex align-items-center">
                                        <img class="me-2" :src="'https://zulutrade.com/'+item.smallLogoUrl" :alt="item.name" :title="item.name" />
                                        {{item.name}}
                                    </span>
                                    <!-- <div class="d-flex align-items-center copyWrap" v-if="item.integrationMode == 'CO_BRANDED'">
                                        <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{$t('select_broker.text3')}}</span>
                                        <div class="tooltipbutton">
                                            <span class="tooltiptext">{{$t('select_broker.text4')}}</span>
                                            <span class="infoIcon position-relative">
                                                <vue-feather class="opcity ms-1" type="info" size="20"></vue-feather>
                                            </span>
                                        </div>
                                    </div> -->
                                    <!-- <div class="d-flex align-items-center copyWrap" v-if="item?.freeCopyTrading && item?.slots && item?.freeCopyTradingPeriodInMonths">
                                        <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{item?.slots}} {{ $t('broker_account.text45') }} {{item?.freeCopyTradingPeriodInMonths}} {{ $t('broker_account.text46') }}</span>
                                    </div> -->
                                </a>
                                <a  href="https://dashboard-global.bdswiss.com/register-v2/"  target="_blank" class="clickAble d-flex align-items-center justify-content-between" :class="[{'disabled' : !item.availableToUser}]" v-if="parseInt(item?.id) == 275">
                                    <span class="dark semibold d-flex align-items-center">
                                        <img class="me-2" :src="'https://zulutrade.com/'+item.smallLogoUrl" :alt="item.name" :title="item.name" />
                                        {{item.name}}
                                    </span>
                                    <!-- <div class="d-flex align-items-center copyWrap" v-if="item.integrationMode == 'CO_BRANDED'">
                                        <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{$t('select_broker.text3')}}</span>
                                        <div class="tooltipbutton">
                                            <span class="tooltiptext">{{$t('select_broker.text4')}}</span>
                                            <span class="infoIcon position-relative">
                                                <vue-feather class="opcity ms-1" type="info" size="20"></vue-feather>
                                            </span>
                                        </div>
                                    </div> -->
                                </a>
                                <div class="showData w-100 border-top p-3" :class="globalaccordian == key?'d-block':'d-none'">
                                    <p class="dark medium">{{$t('select_broker.text7')}}</p>
                                    <div class="d-flex align-items-center flex-wrap dualButton">
                                        <a  class="grd_btn me-4" :href="item.signupUrl" target="_blank" v-if="item.signupUrl">{{$t('select_broker.text8')}}</a>
                                        <router-link to="/broker-account" class="border_btn br-50 gray">{{$t('select_broker.text9')}}</router-link>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="nativeBroker" v-else>
                    <h4>{{$t('select_broker.text13')}}</h4>
                    <p class="mb-0">{{$t('select_broker.text14')}}</p>
                    <p>{{$t('select_broker.text15')}}</p>
                    <div class="allBrokers mt-3" v-if="getparticularBrokersList('CO_BRANDED',store.flavorData.flavorId,'EU').length">
                        <!-- <div class="d-flex align-items-center justify-content-between mb-3">
                            <h4 class="mb-0">{{$t('select_broker.text6')}}</h4>
                            <float-label class="form-group w-220 mb-0 h-40">
                                <input type="text" class="form-control" placeholder="Search Broker" />
                            </float-label>
                        </div> -->
                        <ul class="selectBrokertList">
                            <li class="d-flex align-items-center justify-content-between flex-wrap" v-for="item,key in getparticularBrokersList('CO_BRANDED',store.flavorData.flavorId,'EU')" :key="key">
                                <a @click="(euaccordian != key) ? euaccordian = key : -1" class="clickAble d-flex align-items-center justify-content-between" href="javascript:void(0)" :class="[{'disabled' : !item.availableToUser}]" v-if="parseInt(item?.id) != 275">
                                    <span class="dark semibold d-flex align-items-center">
                                        <img class="me-2" :src="'https://zulutrade.com/'+item.smallLogoUrl" :alt="item.name" :title="item.name" />
                                        {{item.name}}
                                    </span>
                                    <!-- <div class="d-flex align-items-center copyWrap" v-if="item.integrationMode == 'CO_BRANDED'">
                                        <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{$t('select_broker.text3')}}</span>
                                        <div class="tooltipbutton">
                                            <span class="tooltiptext">{{$t('select_broker.text4')}}</span>
                                            <span class="infoIcon position-relative">
                                                <vue-feather class="opcity ms-1" type="info" size="20"></vue-feather>
                                            </span>
                                        </div>
                                    </div> -->
                                    <!-- <div class="d-flex align-items-center copyWrap" v-if="item?.freeCopyTrading && item?.slots && item?.freeCopyTradingPeriodInMonths">
                                        <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{item?.slots}} {{ $t('broker_account.text45') }} {{item?.freeCopyTradingPeriodInMonths}} {{ $t('broker_account.text46') }}</span>
                                    </div> -->
                                </a>
                                <a  href="https://dashboard-global.bdswiss.com/register-v2/"  target="_blank" class="clickAble d-flex align-items-center justify-content-between" :class="[{'disabled' : !item.availableToUser}]" v-if="parseInt(item?.id) == 275">
                                    <span class="dark semibold d-flex align-items-center">
                                        <img class="me-2" :src="'https://zulutrade.com/'+item.smallLogoUrl" :alt="item.name" :title="item.name" />
                                        {{item.name}}
                                    </span>
                                    <!-- <div class="d-flex align-items-center copyWrap" v-if="item.integrationMode == 'CO_BRANDED'">
                                        <span class="semibold flex-shrink-0 f-13 d-flex align-items-center primary">{{$t('select_broker.text3')}}</span>
                                        <div class="tooltipbutton">
                                            <span class="tooltiptext">{{$t('select_broker.text4')}}</span>
                                            <span class="infoIcon position-relative">
                                                <vue-feather class="opcity ms-1" type="info" size="20"></vue-feather>
                                            </span>
                                        </div>
                                    </div> -->
                                </a>
                                <div class="showData w-100 border-top p-3" :class="euaccordian == key?'d-block':'d-none'">
                                    <p class="dark medium">{{$t('select_broker.text7')}}</p>
                                    <div class="d-flex align-items-center flex-wrap dualButton">
                                        <a  class="grd_btn me-4" :href="item.signupUrl" target="_blank" v-if="item.signupUrl">{{$t('select_broker.text8')}}</a>
                                        <router-link to="/broker-account" class="border_btn br-50 gray">{{$t('select_broker.text9')}}</router-link>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Data Featching Loader Here -->

    
    <div class="modal fade giftModal featchData show" v-if="store.singleLoading">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="position-relative d-flex align-items-center justify-content-between overflow-hidden">
                        <div class="featchLogo">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/fxSmal.png`" alt="ZuluTrade" title="ZuluTrade">
                        </div>
                        <div class="position-absolute loader-line">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/ltRts.png`" alt="ZuluTrade" title="ZuluTrade">
                        </div>
                        <div class="featchLogo">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/zulSmal.png`" alt="Fxview" title="Fxview">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { useMainStore } from "@/store";
//import FloatLabel from 'vue-float-label/components/FloatLabel'
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            euaccordian:-1,
            globalaccordian:-1,
            allBrokerList : [],
            showFreeCopy : false
        }
    },
    computed: {
        isActive() {
            return false
        }
    },
    components: {
        //FloatLabel
    },
    watch : {
        'showFreeCopy'(){
            this.euaccordian = -1
            this.globalaccordian = -1
            this.getparticularBrokersList('INTEGRATED');
            this.getparticularBrokersList('CO_BRANDED',this.store.flavorData.flavorId)

        }
    },
    methods:{
        getbrokerSettings(id){
            this.store.callBrokerSettings({},true,id).then((response) => {
                if(Object.keys(this.store.brokerStatusList).length && Object.keys(response).length){
                    this.store.$patch({'linkBrokerID' : null})
                    if(!this.store.brokerStatusList.completed){
                        if(response.REGISTRATION_STEPS_MOBILE && response.REGISTRATION_STEPS_MOBILE.length && ('currentStep' in this.store.brokerStatusList)){
                            if(parseInt(this.store.brokerStatusList.currentStep) == 0){
                                this.store.BrokerSignup({},true,id).then((resp) =>{
                                    if(resp === true){
                                        this.$router.replace({path : '/personalInfo-step1'+'/'+id})
                                    }
                                })
                            }else{
                                let step = parseInt(this.store.brokerStatusList.currentStep) == 0 ? 0 : parseInt(this.store.brokerStatusList.currentStep)-1
                                if(parseInt(this.store.brokerStatusList.currentStep) == 6){
                                    if (this.store.brokerStatusList.stepsStatus[step - 1].porStatus.status == 'REJECTED') {
                                        this.$router.replace({path : '/upload-por'+'/'+id})
                                    }else{
                                        this.$router.replace({path : '/sumsub'+'/'+id})
                                    }
                                }else{
                                    this.$router.replace({path :this.store.StepsJson[response.REGISTRATION_STEPS_MOBILE[step]]+'/'+id})
                                }
                            }
                        }
                    }else{
                        if(this.store.userAccoutDetail.requiredActions && this.store.userAccoutDetail.requiredActions.length){
                            this.$router.replace({path : '/sutaibility'})
                        }else{
                            let path = `${this.static_vars.domainURL}dashboard`
                            window.location.replace(path)
                        }
                    }
                }
            })
        },
        SignUpUser(item){
            this.store.callUserBrokerStatusList({},true,item.id).then(() =>{
                this.getbrokerSettings(item.id)
            })
        },
        getparticularBrokersList(type,flavorID,flavor){
            if(Object.keys(this.store.brokersList).length && this.store.brokersList.brokers && this.store.brokersList.brokers.length){
                if(type == 'INTEGRATED'){
                    if(this.showFreeCopy){
                         return this.store.brokersList.brokers.filter(val => val.integrationMode == 'INTEGRATED' && val.availableToUser).sort(function(a, b){return b.availableToUser - a.availableToUser});
                    }else{
                        return this.store.brokersList.brokers.filter(val => val.integrationMode == 'INTEGRATED' && val.availableToUser).sort(function(a, b){return b.availableToUser - a.availableToUser});
                    }
                }else if(type == 'CO_BRANDED'){
                    if(flavorID && flavorID == 1){
                        if(flavor == 'EU'){
                            if(this.showFreeCopy){
                                return this.store.brokersList.brokers.filter(val => val.integrationMode == 'CO_BRANDED' &&  !val.availableToUser);
                            }else{
                                return this.store.brokersList.brokers.filter(val => val.integrationMode != 'INTEGRATED' &&  !val.availableToUser);
                            }
                        }else{
                            if(this.showFreeCopy){
                                return this.store.brokersList.brokers.filter(val => val.integrationMode == 'CO_BRANDED' &&  val.availableToUser);
                            }else{
                                return this.store.brokersList.brokers.filter(val => val.integrationMode != 'INTEGRATED' &&  val.availableToUser);
                            }
                        }
                    }else if(flavorID && flavorID == 38){
                        if(flavor == 'GLOBAL'){
                            if(this.showFreeCopy){
                                return this.store.brokersList.brokers.filter(val => val.integrationMode == 'CO_BRANDED' &&  !val.availableToUser);
                            }else{
                                return this.store.brokersList.brokers.filter(val => val.integrationMode != 'INTEGRATED' &&  !val.availableToUser);
                            }
                        }else{
                            if(this.showFreeCopy){
                                 return this.store.brokersList.brokers.filter(val => val.integrationMode == 'CO_BRANDED' &&  val.availableToUser);
                            }else{
                                return this.store.brokersList.brokers.filter(val => val.integrationMode != 'INTEGRATED' &&  val.availableToUser);
                            }
                        }
                    }else{
                        if(this.showFreeCopy){
                            return this.store.brokersList.brokers.filter(val => val.integrationMode == 'CO_BRANDED' && val.availableToUser).sort(function(a, b){return b.availableToUser - a.availableToUser});
                        }else{
                            return this.store.brokersList.brokers.filter(val => val.integrationMode != 'INTEGRATED' && val.availableToUser).sort(function(a, b){return b.availableToUser - a.availableToUser});
                        }
                    }
                }
            }
        },
        callBrokerList(){
            this.store.$patch({'brokersList' : {}})
            this.store.getBrokersList({},true).then(()=>{
            })
        },
    },
    created(){
        this.callBrokerList()
    }
}
</script>